'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simple = require('./simple.js');

Object.defineProperty(exports, 'simple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_simple).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/lib/stateMappings/index.js